import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=ccd7860c&scoped=true"
import script from "./ClickToEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClickToEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClickToEdit.vue?vue&type=style&index=0&id=ccd7860c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd7860c",
  null
  
)

export default component.exports